import qs from 'qs';
import history from '../../services/history';
import _ from 'lodash';

const supportedParams = [
  'demo',
  'dateRangeType',
  'from',
  'to',
  'devices',
  'questionFilters',
  'selectedTags',
  'token',
  'print',
];

function getParams(keys) {
  if (!_.isArray(keys)) {
    keys = supportedParams;
  } else {
    const unsupportedParams = _.difference(keys, supportedParams);
    if (unsupportedParams.length > 0) {
      console.warn('Trying to get unknown query string parameters:', unsupportedParams);
      keys = _.without(keys, unsupportedParams);
    }
  }
  const allParams = qs.parse(history.location.search.substr(1)) || {};
  return _.pick(allParams, keys);
}

function getParam(key) {
  if (_.includes(supportedParams, key)) {
    const params = qs.parse(history.location.search.substr(1)) || {};
    return params[key];
  } else {
    console.warn('Trying to get unknown query string parameter:', key);
    return null;
  }
}

export default {
  get: key => {
    if (_.isString(key)) {
      return getParam(key);
    } else if (_.isArray(key)) {
      const keys = key;
      return getParams(keys);
    } else {
      return getParams();
    }
  },
  set: (setParams, replace) => {
    // Check if trying to set unsupported params
    const unsupportedParams = _.difference(_.keys(setParams), supportedParams);
    if (unsupportedParams.length > 0) {
      console.warn('Trying to set unknown query string parameters:', unsupportedParams);
      setParams = _.omit(setParams, unsupportedParams);
    }

    const currentParams = getParams();
    const newParams = _(Object.assign({}, currentParams, setParams)).omitBy(_.isNil).value();
    const historyFunc = replace ? history.replace : history.push;

    // Only change history if something has actually changed
    if (!_.isEqual(currentParams, newParams)) {
      historyFunc(location.pathname.split('?')[0] + '?' + qs.stringify(newParams));
    }
    return newParams;
  },
  getUrlWith: (setParams) => {
    // Check if trying to set unsupported params
    const unsupportedParams = _.difference(_.keys(setParams), supportedParams);
    if (unsupportedParams.length > 0) {
      console.warn('Trying to set unknown query string parameters:', unsupportedParams);
      setParams = _.omit(setParams, unsupportedParams);
    }

    const currentParams = getParams();
    const newParams = _(Object.assign({}, currentParams, setParams)).omitBy(_.isNil).value();

    return window.location.href.split('?')[0] + '?' + qs.stringify(newParams);
  },
};



// WEBPACK FOOTER //
// ./src/services/queryStringParams/queryStringParams.js